import { useLocation, useNavigate } from 'react-router-dom';
import { AppRoutes, KNOWLEDGE_HUB_TYPE_CONFIG } from '../../constants';
import { KnowledgeHubRecordType } from '../../types';
import { getKnowledgeHubIcon } from '../../utils';
import { Icons } from '../shared';
import SidebarButtonGroup from './SidebarButtonGroup';

const KnowledgeHubSidebarContent = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <SidebarButtonGroup
      items={Object.values(KnowledgeHubRecordType).map((type) => {
        const { path: id, color: iconColor } = KNOWLEDGE_HUB_TYPE_CONFIG[type];
        const icon = getKnowledgeHubIcon(type);
        return {
          id,
          active: pathname.includes(id),
          endElement: <Icons icon={icon} color={iconColor} />,
          onClick: () => navigate(AppRoutes.KNOWLEDGE_HUB + '/' + id, { replace: true }),
        };
      })}
    />
  );
};

export default KnowledgeHubSidebarContent;
